import { render } from "./Welcome.vue?vue&type=template&id=6cd5adde&ts=true"
import script from "./Welcome.vue?vue&type=script&lang=ts"
export * from "./Welcome.vue?vue&type=script&lang=ts"

import exportComponent from "/home/jason/.local/share/cdd/projects/default/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__